// Global
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { StyledDateSection, StyledListWrapper, StyledSectionList, StyledSectionTitle } from './AttendeesListStyles';
import AttendeeCard from '../AttendeeCard/AttendeeCard';

// Models
import { IViewingAttendee } from '@/models/viewing.model';

// Helpers
import { renderDate } from '@/utils';
import { DateFormats } from '@/constants/dates';

interface IViewingAttendeeListProps {
  scheduleRecords: Record<string, IViewingAttendee[]>;
}

const ViewingAttendeeList: React.FC<IViewingAttendeeListProps> = ({ scheduleRecords }) => {
  const { t } = useTranslation('viewing');

  return (
    <StyledListWrapper>
      {Object.entries(scheduleRecords).map(([date, attendees]) => {
        return (
          <StyledDateSection key={date}>
            <StyledSectionTitle>{`${date !== 'undefined' ? renderDate(date, DateFormats.DAY_MONTH_WITH_TIME) : ''} ${t(
              attendees.length > 1 ? 'viewing_people_count' : 'viewing_person_count',
              {
                count: attendees.length,
              },
            )}`}</StyledSectionTitle>
            <StyledSectionList>
              {attendees.map((attendee) => (
                <AttendeeCard key={attendee.id} attendee={attendee} />
              ))}
            </StyledSectionList>
          </StyledDateSection>
        );
      })}
    </StyledListWrapper>
  );
};

export default ViewingAttendeeList;
